<!-- 报名影赛 -->
<template>
  <div class="right">
    <div
      class="topImg"
      v-if="
        !detail ||
          !detail.albums_upload_page_content_header ||
          !detail.albums_upload_page_content_header.type
      "
    >
      <img src="@/assets/submitHead.png" />
    </div>
    <div class="topImgTwo" v-else>
      <template v-if="detail.albums_upload_page_content_header.type == 1">
        <img :src="detail.albums_upload_page_content_header.url" />
      </template>
      <template v-else-if="detail.albums_upload_page_content_header.type == 2">
        <!-- <img :src="detail.content_top.url" />
				<div class="topDw">{{detail.content_top.content}}</div> -->
        <div v-html="detail.albums_upload_page_content_header.content">
          {{ detail.albums_upload_page_content_header.content }}
        </div>
      </template>
      <template v-else>
        <div class="topWz">
          {{ detail.albums_upload_page_content_header.content }}
        </div>
      </template>
    </div>
    <div class="contentBox">
      <!-- <div class="title" style="display: flex;justify-content: space-between;">
				<div>报名影赛</div>
				<div>
					<el-button type="primary" style="width:100px;background:#e40001;border:1px solid #e40001;" v-loading="saveLoading" size="medium"
						@click="goBack()">返回</el-button>
				</div>
			</div> -->
      <div class="form">
        <el-form
          :model="form"
          ref="form"
          :rules="rules"
          label-width="96px"
          :inline="false"
          size="medium"
        >
          <el-row :gutter="10">
            <el-col :md="12">
              <el-form-item label="作品标题：" prop="title">
                <el-input
                  type="text"
                  v-model="form.title"
                  placeholder="请输入作品标题
"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <!-- <el-col :md="9">
							<el-form-item label="影赛：" prop="shadow_game_id">
								<el-select v-model="form.shadow_game_id" placeholder="请选择类别" style="width:100%"
									@change="goChange" disabled>
									<el-option v-for="(item,index) in shadow_games" :key="index" :label="item.label"
										:value="item.value" >
									</el-option>
								</el-select>
							</el-form-item>
						</el-col> -->
            <!-- <el-col :md="9">
							<el-form-item label="类别：">
								<el-select v-model="shadow_game_idTwo" placeholder="请选择类别" style="width:100%"
									@change="goChange">
									<el-option v-for="(item,index) in shadow_gamesTwo" :key="index" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col> -->
            <el-col :md="6" v-if="form.shadow_game_id">
              <el-form-item label="所属赛道:" prop="shadow_game_type_id">
                <el-select
                  v-model="form.shadow_game_type_id"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <!-- <el-cascader v-model="typeId" placeholder="请选择" :options="typeList" v-loading="typeLoad"
								@change="handleChange" :props="typeProps"></el-cascader> -->
              </el-form-item>
            </el-col>
     <!-- <el-col :md="6">
              <el-form-item label="报名渠道:" prop="source">
                <el-select
                  v-model="form.source"
                  placeholder="请选择"
                  @change="resetfilds"
                >
                  <el-option
                    v-for="(item, index) in sourceTypeList"
                    :key="index"
                    :label="item"
                    :value="index"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :md="6">
              <el-form-item label="年级:" prop="grade">
                <el-select v-model="form.grade" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in gradeTypeList"
                    :key="index"
                    :label="item"
                    :value="index"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :md="6">
							<el-form-item label="时间：" prop="year">
								<el-date-picker v-model="form.year" format="yyyy" value-format="yyyy" type="year"
									placeholder="选择时间" style="width:100%">
								</el-date-picker>
							</el-form-item>
						</el-col> -->
            <!-- <el-col :md="6">
							<el-form-item label="关键字：" prop="keyword">
								<el-select style="width: 100%" v-model="form.keyword" multiple filterable allow-create
									default-first-option placeholder="请输入关键字">
									<el-option v-for="(item,index) in keyword" :key="index" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col> -->
          </el-row>
          <el-row :gutter="24">
            <el-col :md="12">
              <el-form-item label="学校" prop="school">
                <el-select
                  disabled
                  v-if="form.source == 1"
                  v-model="form.school"
                  placeholder="请选择学校"
                  style="width: 100%;"
                >
                  <el-option label="深圳大学" value="深圳大学"> </el-option>
                  <el-option label="同济大学" value="同济大学"> </el-option>
                  <el-option label="西安美术学院" value="西安美术学院">
                  </el-option>
                </el-select>
                <el-input
                  v-else
                  clearable
                  v-model="form.school"
                  placeholder="请输入学校"
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="姓名" prop="name">
                <el-input
                  clearable
                  v-model="form.name"
                  placeholder="请输入姓名"
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="联系方式" prop="phone">
                <el-input
                  clearable
                  v-model="form.phone"
                  placeholder="请输入手机号"
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="专业" prop="speciality">
                <el-input
                  clearable
                  v-model="form.speciality"
                  placeholder="请输入专业"
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="通讯地址">
                <el-input
                  clearable
                  v-model="form.address"
                  placeholder="请输入通讯地址"
                />
              </el-form-item>
            </el-col>

            <el-col :md="12">
              <el-form-item label="作品信息" prop="info">
                <el-input
                  type="textarea"
                  clearable
                  v-model="form.info"
                  placeholder="请输入作品信息"
                />
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-form-item label="作品描述：" prop="desc" label-width="96px">
                <el-input
                  type="textarea"
                  v-model="form.desc"
                  placeholder="请输入内容，至少填写15个字符"
                  :rows="6"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="10">
						<el-col :md="24">
							<el-form-item label="封面：" prop="cover">
								<ChooseImg path="shadow_game_photo" v-model="form.cover"></ChooseImg>
							</el-form-item>
						</el-col>
					</el-row> -->
          <el-row :gutter="10">
            <el-col :md="24">
              <el-form-item label="图集：" prop="images">
                <ChooseImg
                  path="shadow_game_photo"
                  v-model="form.images"
                  :limit="9"
                  :isAllValue="true"
                >
                </ChooseImg>
                <div class="tipbox">参赛图集第一张图片将作为图集封面展示</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :md="24">
              <el-form-item label="">
                <div class="statement">
                  <el-checkbox v-model="isSelect">原创声明 </el-checkbox>
                  <!-- <el-link @click="toAgreement('privacy_policy')" type="primary"
										:underline="false">《隐私政策》</el-link> -->
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button
              type="primary"
              style="width:100px;background:#e40001;border:1px solid #e40001;"
              v-loading="saveLoading"
              size="medium"
              @click="save"
              >保存</el-button
            >
            <el-button
              type="primary"
              style="width:100px;background:#e40001;border:1px solid #e40001;"
              v-loading="saveLoading"
              size="medium"
              @click="goBack()"
              >返回</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  submit_shadow_gameAPI,
  getDictAPI,
  shadow_game_child_type_treeAPI,
  get_grade_typeAPI,
  get_source_typePI,
} from "@/api/submit.js";
import ChooseImg from "@/components/chooseImg/chooseImg.vue";
import { getShadowGameDetailAPI } from "@/api/index.js";
import { getShadowGameRoute } from "@/utils/shadowGameRoute";
export default {
  components: {
    ChooseImg,
  },
  data() {
    return {
      form: {
        images: [],
        shadow_game_type_id: "",
        shadow_game_id: "",
        cover: "",
        title: "",
        speciality: "",
        school: "",
        name: "",
        phone: "",
        info: "",
        address: "",
        desc: "",
        grade: "",
        source: 2,
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        shadow_game_id: [
          {
            required: true,
            message: "请选择影集",
            trigger: "change",
          },
        ],
        shadow_game_type_id: [
          {
            required: true,
            message: "请选择赛道",
            trigger: "change",
          },
        ],
        source: [
          {
            required: true,
            message: "请选择报名渠道",
            trigger: "change",
          },
        ],
        grade: [
          {
            required: true,
            message: "请选择年级",
            trigger: "change",
          },
        ],
        school: [
          {
            required: true,
            message: "请输入学校",
            trigger: ["blur", "change"],
          },
        ],
        // year: [{
        // 	required: true,
        // 	message: "请选择时间",
        // 	trigger: "change"
        // }],
        // keyword: [{
        // 	required: true,
        // 	message: "请输入关键字",
        // 	trigger: "blur"
        // }],
        // cover: [{
        // 	required: true,
        // 	message: "请选择封面",
        // 	trigger: "blur"
        // }],
        images: [
          {
            required: true,
            message: "请选择图集",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "blur",
          },
        ],
        desc: [
          {
            required: true,
            message: "请输入作品描述",
            trigger: "blur",
          },
          { min: 15, message: "最少输入15个字!", trigger: "blur" },
        ],
      },
      //影集
      shadow_games: [],
      //关键字
      keyword: [],
      isSelect: false,
      saveLoading: false,
      typeId: "",
      typeList: [],
      typeLoad: false,
      typeProps: {
        value: "id",
        label: "name",
      },
      shadow_gamesTwo: [],
      shadow_game_idTwo: "",
      sourceTypeList: [],
      gradeTypeList: [],
      detail: {},
    };
  },
  created() {},
  mounted() {
    document.title = "上传作品";
    this.form.shadow_game_id = getShadowGameRoute(this.$route.query.id).gameId;
    // this.shadow_game_idTwo = Number(this.$route.query.id) || 12;

    // this.form.shadow_game_type_id = Number(this.$route.query.typeId) || "";
    this.form.shadow_game_type_id = "";
    setTimeout(() => {
      console.log('-----------typeList',this.typeList)
    }, 5000);
    this.getDict();
    this.getSourceType();
    this.geGradeType();
    this.getDetail();
  },
  watch: {
    "form.shadow_game_id"() {
      this.typeId = "";
      if (this.form.shadow_game_id) {
        this.getThreeType();
      }
    },
    "form.source"() {
      if (this.form.source == 1) {
        this.form.school = "深圳大学";
      } else {
        this.form.school = "";
      }
    },
  },
  methods: {
    resetfilds() {
      this.$refs.form.clearValidate("school");
    },
    getDetail() {
      let data = {
        id: this.form.shadow_game_id,
      };
      getShadowGameDetailAPI(data)
        .then((res) => {
          console.log(res);
          this.detail = res.data;
          if (this.detail.albums_upload_page_content_header.type) {
            this.detail.albums_upload_page_content_header.content = this.removePreAndCodeTags(
              this.detail.albums_upload_page_content_header.content
            );
            this.detail.albums_upload_page_content_header.content = this.replaceAngleBrackets(
              this.detail.albums_upload_page_content_header.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.albums_upload_page_content_header.content = this.detail.albums_upload_page_content_header.content.replace(
              regex,
              `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removePreAndCodeTags(htmlString) {
      const regex = /<pre[^>]*>|<code[^>]*>|<\/pre>|<\/code>/gi;
      return htmlString.replace(regex, "");
    },
    replaceAngleBrackets(str) {
      return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    },
    toAgreement(val) {
      let url = this.$router.resolve({
        path: "/agreement?key=" + val,
      });
      window.open(url.href, "_blank" + url.href);
    },

    save() {
      console.log(this.form);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (!this.isSelect) {
            this.$notify.error({
              title: "报名失败",
              message: "非原创作品禁止上传",
            });
            return;
          }
          this.saveLoading = true;

          // shadow_game_id,
          // title,
          // year,
          // keyword,
          // cover,
          // desc,
          let { images } = this.form;
          let arr = images.map((ele) => {
            let obj = {
              title: ele.fileName,
              desc: "",
              url: ele.url,
            };
            return obj;
          });
          let param = {
            ...this.form,
            images: arr,
            cover: images[0].url,
          };
          console.log("----------数据", param);
          submit_shadow_gameAPI(param)
            .then((res) => {
              if (res.code == 200) {
                this.$refs.form.resetFields();
                this.form = {
                  images: [],
                  shadow_game_type_id: "",
                  shadow_game_id: "",
                  cover: "",
                  title: "",
                  speciality: "",
                  school: "",
                  name: "",
                  phone: "",
                  info: "",
                  address: "",
                  grade: "",
                  source: "",
                };
                this.$message.success(res.msg);
                this.$router.go(-1);
              }
            })
            .finally(() => {
              this.saveLoading = false;
            });
        }
      });
    },
    // 获取字典
    getDict() {
      getDictAPI({
        dict: ["shadow_games"],
      }).then((res) => {
        let {
          data: { shadow_games },
        } = res;
        this.shadow_games = shadow_games;
      });
    },
    //去除文件名
    getFileName(data) {
      return data.substring(0, data.lastIndexOf("."));
    },
    getThreeType() {
      let data = {
        id: this.form.shadow_game_id,
      };
      this.typeLoad = true;
      shadow_game_child_type_treeAPI(data)
        .then((res) => {
          console.log(res);
          // this.typeList = res.data;
          this.typeLoad = false;
          let list = res.data;
          let lista = [];
          this.shadow_gamesTwo = res.data;
          list.map((v) => {
            // if (this.shadow_game_idTwo == v.id) {
            // 	lista = v.children
            // }
            v.children.map((a) => {
              lista.push(a);
            });
          });
          this.$nextTick(function() {
            this.typeList = lista;
            // this.typeList = res.data.children;
          });
        })
        .catch((err) => {
          this.typeLoad = false;
          console.log(err);
        });
    },
    handleChange(e) {
      console.log(e);
      this.form.shadow_game_type_id = e[e.length - 1];
    },
    goBack() {
      // this.$router.go(-1)
      if (document.referrer) {
        this.$router.go(-1);
        // 如果有上一页，返回上一页
        // if (document.referrer.indexOf("mp.csdn.net") > -1) {
        // 	this.$router.go(-1);
        // } else {
        // 	window.location.href = 'index.php';
        // }
      } else {
        // 没有上一页，重定向到index.php页面
        this.$router.push({ path: "/", query: { id: getShadowGameRoute(this.$route.query.id).publicId } });
      }
    },
    goChange(e) {
      console.log(e);
      let list = this.shadow_gamesTwo;
      let typeList = [];
      list.map((v) => {
        if (v.id == e) {
          typeList = v.children;
        }
      });
      this.$nextTick(function() {
        this.typeList = typeList;
      });
      // this.typeList=
    },
    // 获取年级
    geGradeType() {
      get_grade_typeAPI({}).then((res) => {
        this.gradeTypeList = res.data;
      });
    },
    // 获取报名渠道
    getSourceType() {
      get_source_typePI({}).then((res) => {
        this.sourceTypeList = res.data;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.right {
  border: 1px solid #d7d7d7;
  // padding: 24px;
  box-sizing: border-box;
  border-left: none;

  .form {
    padding: 30px 10px 0px;
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 40px;
    border-bottom: 1px solid #c9c9c9;
    font-family: "微软雅黑";
  }

  .prompt {
    font-size: 12px;
    color: #8a8a8a;
    line-height: 22px;
  }

  .statement {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #757575;
  }

  @media (max-width: 768px) {
    .statement {
      flex-wrap: wrap;
    }
  }
}

.contentBox {
  max-width: 1200px;
  margin: 0 auto;
}

.topImg {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;

  img {
    max-width: 220px;
    display: block;
    margin: 0;
    padding: 0;
  }
  .topDw {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }

  .topWz {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin: 20px 0;
  }
}

::v-deep {
  .el-form-item__label {
    font-family: "微软雅黑";
  }
}
.topImgTwo {
  width: 100%;
  position: relative;

  img {
    width: 100%;
    display: block;
    margin: 0;
    padding: 0;
  }

  .topDw {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }

  .topWz {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin: 20px 0;
  }
}

.tipbox {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}
</style>
